module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/BEST_PRICES.2b0df0ba.svg";